import logoAsisaBlue from "./logo-asisa-blue.svg";
import logoAsisaWhite from "./logo-asisa-white.svg";

export const icons = {
  // logo
  logoAsisaBlue: logoAsisaBlue,
  logoAsisaWhite: logoAsisaWhite,
}